(function () {
  'use strict';

  function initSlider(section) {
    var track = section.querySelector('.bm-reviews__track');
    if (!track) return;

    var prevBtn = section.querySelector('.bm-reviews__arrow--prev');
    var nextBtn = section.querySelector('.bm-reviews__arrow--next');
    var cards = track.querySelectorAll('.bm-reviews__card');
    var idx = 0;
    var visibleCount = 3;

    function cardWidth() {
      return cards[0] ? cards[0].offsetWidth + 24 : 424;
    }

    function maxIdx() {
      return Math.max(0, cards.length - visibleCount);
    }

    function update() {
      track.style.transform = 'translateX(-' + (idx * cardWidth()) + 'px)';
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx >= maxIdx();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (idx > 0) {
          idx--;
          update();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (idx < maxIdx()) {
          idx++;
          update();
        }
      });
    }

    window.addEventListener('resize', function () {
      idx = Math.min(idx, maxIdx());
      update();
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('.bm-reviews').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init on section load/reorder
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bm-reviews');
    if (section) initSlider(section);
  });
})();
